'use strict';
intellidealerAppMyAccountModule.controller('InvoicesController', function ($scope, $state, $stateParams, accountSummary, invoices, appConfigurationService, invoiceHistoryResource,
                                                                           globalAlertService, invoicesFilters, locations, $uibModal, searchValues, search, myProfile, $location,
                                                                           $anchorScroll, $filter, userConfiguration, division1, twocpResource, worldpayResource, $window, dealerDivisionSettings,
                                                                           achPaymentAgencies, paymentAgencies, sessionService, authorizeDotNetResource, authDotNetProperties, worldpayUrlService, $q) {

  var isTimeout;
  var timeOutId;
  var selectedInvoiceList;
  $scope.showLocation = division1.printLocationSuffix;
  $scope.dealerDivisionSettings = dealerDivisionSettings;
  $scope.achPaymentAgencies = achPaymentAgencies;
  $scope.paymentAgencies = paymentAgencies;
  $scope.searchedStatus = $stateParams.invoicesFilters ? angular.fromJson($stateParams.invoicesFilters).status : null;
  $scope.usesInHouseAR = userConfiguration.usesInHouseAR;
  $scope.payByCreditCard = !$scope.paymentAgencies.disableTwoCP;
  $scope.payByWorldPay = !!$scope.paymentAgencies.showWorldPay && !!$scope.paymentAgencies.showWorldPayPayment;
  $scope.payByAuthDotNet = !!($scope.usesInHouseAR &&
    sessionService.getFeatures()['PFW.6286'] &&
    authDotNetProperties &&
    authDotNetProperties.apiLoginId &&
    authDotNetProperties.transactionKey &&
    ['ACH_PAYMENT', 'BOTH_PAYMENT_TYPES'].includes(userConfiguration.allowPaymentsOnAccount) &&
    authDotNetProperties.locations.some(loc => {
      const beforeDash = loc.split(' - ')[0];
      return beforeDash === userConfiguration.contactId.company + '/' + userConfiguration.contactId.division + '/' + userConfiguration.businessLocation;
    }));
  $scope.allowPayment =
    $scope.usesInHouseAR &&
    userConfiguration.allowPaymentsOnAccount !== 'NONE' &&
    (
      ($scope.achPaymentAgencies.worldpayACHEnabled && ['ACH_PAYMENT', 'BOTH_PAYMENT_TYPES'].includes(userConfiguration.allowPaymentsOnAccount)) ||
      ($scope.achPaymentAgencies.twoCPACHEnabled && ['ACH_PAYMENT', 'BOTH_PAYMENT_TYPES'].includes(userConfiguration.allowPaymentsOnAccount)) ||
      ($scope.payByWorldPay && ['CREDIT_CARD_PAYMENT', 'BOTH_PAYMENT_TYPES'].includes(userConfiguration.allowPaymentsOnAccount)) ||
      ($scope.payByCreditCard && ['CREDIT_CARD_PAYMENT', 'BOTH_PAYMENT_TYPES'].includes(userConfiguration.allowPaymentsOnAccount)) ||
      $scope.payByAuthDotNet
    );
  $scope.myProfile = myProfile;
  $scope.paySelectedEnabled = false;


  if ($scope.searchedStatus === 'O' && !userConfiguration.usesInHouseAR) {
    $scope.searchedStatus = 'P';
  }

  if (($scope.searchedStatus === 'P') ||
    ($scope.paymentAgencies.disableTwoCP && !$scope.paymentAgencies.showWorldPay &&
      !$scope.achPaymentAgencies.twoCPACHEnabled && !$scope.achPaymentAgencies.worldpayACHEnabled && !$scope.payByAuthDotNet)) {
    $scope.allowPaymentsOnAccount = 'NONE';
  } else {
    $scope.allowPaymentsOnAccount = userConfiguration.allowPaymentsOnAccount;
  }

  //summary values
  $scope.accountSummary = accountSummary;
  $scope.accountSummary.overdue =
    ($scope.accountSummary.aged60 ? $scope.accountSummary.aged60 : 0) +
    ($scope.accountSummary.aged90 ? $scope.accountSummary.aged90 : 0) +
    ($scope.accountSummary.aged120 ? $scope.accountSummary.aged120 : 0) +
    ($scope.accountSummary.agedOver120 ? $scope.accountSummary.agedOver120 : 0);

  //invoice list values
  $scope.locations = locations;
  $scope.searchValues = searchValues;
  $scope.invoices = invoices;
  $scope.invoices.content.forEach(function (invoice) {

    if (invoice.appliedAmount && invoice.appliedAmount !== 0) {
      invoice.appliedAmountSelected = Math.abs(invoice.appliedAmount).toFixed(2);
    }
  });

  $scope.getLocation = function () {
    if (!achPaymentAgencies.customerLocation) {
      return dealerDivisionSettings.achBatchLocation;
    } else {
      return userConfiguration.businessLocation;
    }
  };

  $scope.irInvoiceUndefined = function (invoiceNumber) {
    return invoiceNumber === undefined;
  };

  $scope.updateSelected = function (invoice) {
    if ($scope.hasAmount(invoice.appliedAmountSelected)) {
      sessionStorage.setItem(invoice.transactionIdString + 'amt', invoice.appliedAmountSelected);
      sessionStorage.setItem(invoice.transactionIdString + 'chk', 'true');
      sessionStorage.removeItem(invoice.transactionIdString + 'unchk');
    } else {
      sessionStorage.removeItem(invoice.transactionIdString + 'amt');
      sessionStorage.removeItem(invoice.transactionIdString + 'chk');
      if (sessionStorage.getItem('selectAllToggle') === 'true') {
        sessionStorage.setItem(invoice.transactionIdString + 'unchk', 'true');
      } else {
        sessionStorage.removeItem(invoice.transactionIdString + 'unchk');
      }
    }
    invoice.selected = $scope.hasAmount(invoice.appliedAmountSelected);
    $scope.calculateTotalAppliedAmount();
  };

  $scope.paymentDisabled = function (invoice) {
    return $scope.hasAmount(invoice.appliedAmount) || invoice.outstandingAmount < 0;
  };

  // Calculate total applied amount for selected invoices and set paySelectedEnabled flag.
  $scope.calculateTotalAppliedAmount = function() {
    $scope.paySelectedEnabled = $scope.invoices.content
      .filter(invoice => invoice.selected && $scope.hasAmount(invoice.appliedAmountSelected))
      .reduce((total, invoice) => total + parseFloat(invoice.appliedAmountSelected), 0) > 0;
  };

  $scope.hasAmount = function (amount) {
    return amount && amount !== .00 && amount !== 0.0 && amount !== 0.00;
  };

  $scope.email = {
    address: myProfile.businessEmailAddress
  };
  $scope.emailForm = {};
  $scope.filters = invoicesFilters || {};
  $scope.showFilters = !!(
    $scope.filters.type ||
    $scope.filters.location ||
    $scope.filters.minDate ||
    $scope.filters.maxDate ||
    $scope.filters.status
  );
  $scope.terms = {keywords: search};
  $scope.anySelected = false;
  $scope.taxSummary = {};


  $scope.sortChoices = [
    {
      label: $filter('language')('mydealer.ui.global.date'),
      property: 'billingDate',
      direction: 'asc',
      isHidden: false
    },
    {
      label: $filter('language')('mydealer.ui.invoices.invoice_number'),
      property: 'integratedRentalDetails.invoiceNumber,billingHistoryCashReceiptId.salesOrderNumber,invoiceNumber',
      direction: 'asc',
      isHidden: false
    },
    {
      label: $filter('language')('mydealer.ui.invoices.po_number'),
      isHidden: false,
      property: 'purchaseOrderNumber',
      direction: 'asc'
    },
    {
      label: $filter('language')('mydealer.ui.global.location'),
      property: $scope.searchedStatus === 'P' ? 'location' : 'billingHistoryCashReceiptId.location',
      direction: 'asc',
      isHidden: false
    },
    {
      label: $filter('language')('mydealer.ui.global.department'),
      property: 'invoiceType',
      direction: 'asc',
      isHidden: false
    },
    {
      label: $filter('language')('mydealer.ui.invoices.amount'),
      property: 'invoiceTotal',
      direction: 'asc',
      align: 'right',
      isHidden: false
    }
  ];
  if ($scope.searchedStatus === 'P') {
    $scope.sortChoices.splice(2, 0,
      {
        label: $filter('language')('mydealer.ui.invoices.contract_number'),
        property: 'contractNumber',
        isHidden: false,
        direction: 'asc'
      }
    );
    $scope.sortChoices.splice(6, 1);
  }
  if ($scope.searchedStatus === 'O') {
    $scope.sortChoices.push(
      {
        label: $filter('language')('mydealer.ui.invoices.outstanding'),
        property: 'outstandingAmount',
        direction: 'asc',
        align: 'right',
        isHidden: false
      }
    );
    if ($scope.allowPaymentsOnAccount !== 'NONE' && $scope.usesInHouseAR) {
      $scope.sortChoices.push({
        label: $filter('language')('mydealer.ui.invoices.applied'),
        align: 'left',
        isHidden: false
      });
    }
  }
  if ($scope.searchedStatus === 'P') {
    $scope.sortChoices.push(
      {
        label: $filter('language')('mydealer.ui.invoices.amount'),
        isHidden: false,
        align: 'right'
      }
    );
  }
  $scope.sortChoicesDefault = angular.copy($scope.sortChoices);
  $scope.sortChoices.push({});
  if (!sessionStorage.getItem("sortChoices")) {
    sessionStorage.setItem("sortChoices", JSON.stringify($scope.sortChoices))
  } else {
    $scope.sortChoices = JSON.parse(sessionStorage.getItem("sortChoices"));
  }

  $scope.columns = [];

  $scope.sortChoices.forEach(choice => {
    if (choice.label && choice.label != $filter('language')('mydealer.ui.invoices.applied')) {
      $scope.columns.push({label: choice.label, isSelected: true});
    }
  });
  if (!sessionStorage.getItem("columns")) {
    sessionStorage.setItem("columns", JSON.stringify($scope.columns))
  } else {
    $scope.columns = JSON.parse(sessionStorage.getItem("columns"));
  }
  $scope.toggleColumns = function (col) {
    let index = $scope.columns.findIndex(column => {
      return column.label === col.label;
    });
    $scope.columns[index].isSelected = !$scope.columns[index].isSelected;
    sessionStorage.setItem("columns", JSON.stringify($scope.columns))
    let sortIndex = $scope.sortChoices.findIndex(sortChoice => {
      return sortChoice.label === col.label;
    });
    if (sortIndex >= 0) {
      $scope.sortChoices[sortIndex].isHidden = !$scope.columns[index].isSelected;
      sessionStorage.setItem("sortChoices", JSON.stringify($scope.sortChoices))
    }

  }

  $scope.isColVisible = function (colName) {
    let index = $scope.columns.findIndex(column => {
      return column.label === colName;
    });
    return $scope.columns[index].isSelected;
  }

  $scope.$watch(function () {
    var anySelected = false;
    $scope.invoices.content.forEach(function (current) {
      if (current.selected) {
        anySelected = true;
      }
    });
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes("chk") && !key.includes("unchk"))
        anySelected = true;
    })
    return anySelected;
  }, function (newValue) {
    $scope.anySelected = newValue;
  });

  $scope.searchOutstanding = function () {
    $scope.filters.status = "O";
    $scope.filters.minDate = "";

    sessionStorage.clear();
    $scope.search();
  };

  var now = new Date();

  $scope.searchHistorical = function () {
    $scope.filters.status = "P";
    if (!$scope.filters.minDate) {
      var fromDate = new Date(now.getFullYear(), now.getMonth() - 3, 1)
      $scope.filters.minDate = fromDate;
    }

    sessionStorage.clear();
    $scope.search();
  };

  var paymentSubmitDialogInstance = null;
  var pendingWorldpayInvoicePaymentRetryWrapper = null;
  var pendingWorldpayInvoicePaymentSelectedInvoices = null;

  function showPaymentSubmitDialog() {
    if (!paymentSubmitDialogInstance) {
      $uibModal.open({
        templateUrl: 'app/scripts/modules/my-account/views/templates/payment-submitting-prompt.html',
        scope: $scope,
        controller: function ($uibModalInstance) {
          paymentSubmitDialogInstance = $uibModalInstance;
        },
        size: 'md',
        animation: true,
        windowClass: 'center-modal',
        keyboard: false,
        backdrop: 'static'
      });
    }
  }

  function hidePaymentSubmitDialog() {
    if (paymentSubmitDialogInstance) {
      paymentSubmitDialogInstance.dismiss();
      paymentSubmitDialogInstance = null;
    }
  }

  // Worldpay return handling.
  // Enhanced HPP lands as: /?ExpressResponseCode=0&TransactionID=...#/LIB/invoices?SalesOrderNumber=...&HostedPaymentStatus=Complete
  // Pre-hash query + hash query together confuse Angular $location — parse both manually and clean the URL immediately.
  function parseQueryString(queryString) {
    var params = {};
    if (!queryString) {
      return params;
    }
    var q = queryString.charAt(0) === '?' ? queryString.substring(1) : queryString;
    if (!q) {
      return params;
    }
    q.split('&').forEach(function (pair) {
      var parts = pair.split('=');
      var key = decodeURIComponent(parts[0]);
      var value = parts.length > 1 ? decodeURIComponent(parts[1].replace(/\+/g, ' ')) : '';
      if (key && value) {
        params[key] = value;
      }
    });
    return params;
  }

  function getWorldpayReturnParams() {
    // Only treat this as a Worldpay return when the browser URL/session stash shows a *fresh*
    // redirect. Do not use sticky $stateParams alone — HostedPaymentStatus=Cancelled was
    // re-firing the error every time invoices was re-opened.
    var params = {};
    var fresh = false;

    try {
      var stashed = sessionStorage.getItem('_worldpayReturnParams');
      if (stashed) {
        angular.extend(params, JSON.parse(stashed));
        sessionStorage.removeItem('_worldpayReturnParams');
        fresh = true;
      }
    } catch (e) { /* ignore */ }

    var searchParams = parseQueryString($window.location.search);
    if (searchParams.HostedPaymentStatus || searchParams.TransactionSetupID || searchParams.ExpressResponseCode) {
      angular.extend(params, searchParams);
      fresh = true;
    }

    var hash = $window.location.hash || '';
    var hashQueryIndex = hash.indexOf('?');
    if (hashQueryIndex >= 0) {
      var hashParams = parseQueryString(hash.substring(hashQueryIndex));
      if (hashParams.HostedPaymentStatus || hashParams.TransactionSetupID || hashParams.ExpressResponseCode) {
        angular.extend(params, hashParams);
        fresh = true;
      }
    }

    params._isFreshWorldpayReturn = fresh;
    return params;
  }

  var pendingWorldpayInvoiceReturnState = null;

  var clearedWorldpayReturnStateParams = {
    HostedPaymentStatus: null,
    SalesOrderNumber: null,
    TransactionSetupID: null,
    TransactionID: null,
    errorRefNumber: null,
    ExpressResponseCode: null,
    ExpressResponseMessage: null,
    AVSResponseCode: null,
    CVVResponseCode: null,
    ApprovalNumber: null,
    LastFour: null,
    ValidationCode: null,
    CardLogo: null,
    ApprovedAmount: null,
    ServicesID: null,
    PaymentAccountID: null,
    CommercialCardResponseCode: null,
    TipAmount: null
  };

  function clearWorldpayReturnUrl() {
    var hash = $window.location.hash || '';
    var hashPath = hash.split('?')[0];
    if ($window.location.search || hash.indexOf('?') >= 0) {
      $window.history.replaceState(null, '', $window.location.pathname + hashPath);
    }
    if ($stateParams.HostedPaymentStatus || $stateParams.SalesOrderNumber || $stateParams.TransactionSetupID) {
      $state.go('.', clearedWorldpayReturnStateParams, { inherit: true, notify: false, location: 'replace' });
    }
  }

  function buildInvoiceReturnState() {
    return {
      invoicesPagination: $stateParams.invoicesPagination,
      invoicesFilters: $stateParams.invoicesFilters,
      search: $stateParams.search
    };
  }

  function restoreInvoiceReturnState(options) {
    options = options || {};
    var returnState = pendingWorldpayInvoiceReturnState || {};
    var params = angular.extend({}, clearedWorldpayReturnStateParams);
    if (returnState.invoicesPagination) {
      params.invoicesPagination = returnState.invoicesPagination;
    }
    if (returnState.invoicesFilters) {
      params.invoicesFilters = returnState.invoicesFilters;
    }
    if (returnState.search !== undefined) {
      params.search = returnState.search;
    }
    if (options.forceRefresh) {
      params.forceRefresh = Math.random();
    }
    $state.go('.', params, { inherit: true, notify: options.notify !== false, location: 'replace' });
  }

  function finishWorldpayInvoiceSession(options) {
    worldpayUrlService.clearInvoicePaymentSession();
    restoreInvoiceReturnState(options);
  }

  function clearPaidInvoiceSelectionStorage(selectedInvoices) {
    (selectedInvoices || []).forEach(function (invoice) {
      var transactionId = invoice.transactionId || invoice.transactionIdString;
      if (!transactionId) {
        return;
      }
      sessionStorage.removeItem(transactionId + 'amt');
      sessionStorage.removeItem(transactionId + 'chk');
      sessionStorage.removeItem(transactionId + 'unchk');
    });
  }

  function usesWorldpayInvoicePayment() {
    return ($scope.payByWorldPay && ['CREDIT_CARD_PAYMENT', 'BOTH_PAYMENT_TYPES'].includes($scope.allowPaymentsOnAccount)) ||
      ($scope.achPaymentAgencies.worldpayACHEnabled && ['ACH_PAYMENT', 'BOTH_PAYMENT_TYPES'].includes($scope.allowPaymentsOnAccount));
  }

  if (!usesWorldpayInvoicePayment() && worldpayUrlService.hasPendingInvoicePayment()) {
    worldpayUrlService.clearInvoicePaymentSession();
  }

  function parseStoredInvoicePaymentDetails() {
    try {
      return JSON.parse(worldpayUrlService.getStoredInvoicePaymentDetails());
    } catch (e) {
      return null;
    }
  }

  function buildWorldpayInvoiceResultsFromReturnParams(params) {
    return {
      hostedPaymentStatus: params.HostedPaymentStatus || 'Complete',
      hostResponseCode: params.HostResponseCode,
      errorRefNumber: params.errorRefNumber || params.ErrorRefNumber,
      hostResponseMessage: params.HostResponseMessage,
      transactionSetupID: params.TransactionSetupID,
      transactionID: params.TransactionID,
      expressResponseCode: params.ExpressResponseCode,
      expressResponseMessage: params.ExpressResponseMessage,
      avsResponseCode: params.AVSResponseCode,
      cvvResponseCode: params.CVVResponseCode,
      approvalNumber: params.ApprovalNumber,
      lastFour: params.LastFour,
      achAcctNumLastFour: params.ACHAcctNumLastFour,
      validationCode: params.ValidationCode,
      cardLogo: params.CardLogo,
      approvedAmount: params.ApprovedAmount,
      servicesID: params.ServicesID,
      paymentAccountID: params.PaymentAccountID,
      commercialCardResponseCode: params.CommercialCardResponseCode,
      tipAmount: params.TipAmount
    };
  }

  function isBrowserPageReload() {
    try {
      var nav = $window.performance && $window.performance.getEntriesByType &&
        $window.performance.getEntriesByType('navigation')[0];
      if (nav) {
        return nav.type === 'reload';
      }
      return $window.performance && $window.performance.navigation &&
        $window.performance.navigation.type === 1;
    } catch (e) {
      return false;
    }
  }

  function isTransientInvoicePaymentApplyFailure(response) {
    if (!response) {
      return true;
    }
    var status = response.status;
    if (status === 0 || status === 408 || status === 502 || status === 503 || status === 504) {
      return true;
    }
    var data = response.data;
    if (data && (data.messageProperty || data.message || data.type || data.lastError || data.successful === false)) {
      return false;
    }
    return status >= 500;
  }

  function handleReadInvoicePaymentApplyFailure(response, wrapper) {
    globalAlertService.handleErrorResponse(response);
    hidePaymentSubmitDialog();
    if (isTransientInvoicePaymentApplyFailure(response) && wrapper) {
      worldpayUrlService.persistInvoicePaymentApplyWrapper(wrapper);
      restoreInvoiceReturnState();
    } else {
      finishWorldpayInvoiceSession();
    }
  }

  function handleReadInvoicePaymentApplyResponse(data, wrapper, selectedInvoices, worldpayResults) {
    var hasSurcharge = data.expressResponse && data.expressResponse.expressResponseMessage === 'Success' &&
      data.expressResponse.transaction && data.expressResponse.transaction.surchargeAmount;
    if (hasSurcharge) {
      promptWorldpayInvoiceSurchargeAcceptance(data, wrapper);
      return;
    }
    validateWorldpayInvoiceResponse(data, selectedInvoices, worldpayResults, wrapper);
  }

  function submitWorldpayInvoiceApply(wrapper, selectedInvoices, worldpayResults) {
    showPaymentSubmitDialog();
    worldpayResource.readInvoicePayment.post(wrapper).$promise.then(function (data) {
      handleReadInvoicePaymentApplyResponse(data, wrapper, selectedInvoices || wrapper.customerPayInvoiceDTOList || [],
        worldpayResults || wrapper.worldpayResults);
    }).catch(function (response) {
      handleReadInvoicePaymentApplyFailure(response, wrapper);
    });
  }

  function isWorldpayInvoiceReturn(params) {
    if (!params || !params._isFreshWorldpayReturn) {
      return false;
    }
    if (params.HostedPaymentStatus === 'Complete' || params.HostedPaymentStatus === 'Cancelled' ||
      params.HostedPaymentStatus === 'Error') {
      return true;
    }
    return !!(params.TransactionSetupID && params.ExpressResponseCode !== undefined && params.ExpressResponseCode !== null &&
      worldpayUrlService.hasPendingInvoicePayment());
  }

  function isWorldpayInvoicePaymentApproved(params) {
    if (!params || params.HostedPaymentStatus === 'Cancelled' || params.HostedPaymentStatus === 'Error') {
      return false;
    }
    if (params.HostedPaymentStatus === 'Complete') {
      return true;
    }
    var code = params.ExpressResponseCode;
    if ((code === undefined || code === null || code === '') && params.HostResponseCode === '00') {
      code = '0';
    }
    return String(code) === '0' && !!params.TransactionID;
  }

  function cancelPendingWorldpayInvoicePayment(paymentDetails, worldpayReturnParams) {
    globalAlertService.clearErrors();
    var cancelParameters = paymentDetails && paymentDetails.parameters;
    var invoiceNumber = (worldpayReturnParams && worldpayReturnParams.SalesOrderNumber) ||
      (cancelParameters && cancelParameters.preGeneratedInvoiceNumber);
    var cancelPromise = $q.when();
    if (invoiceNumber && (cancelParameters || userConfiguration.contactId)) {
      cancelPromise = worldpayResource.readInvoicePayment.post({
        company: cancelParameters ? cancelParameters.company : userConfiguration.contactId.company,
        division: cancelParameters ? cancelParameters.division : userConfiguration.contactId.division,
        location: cancelParameters ? cancelParameters.location : $scope.getLocation(),
        preGeneratedInvoiceNumber: invoiceNumber,
        worldpayResults: { hostedPaymentStatus: 'Cancelled' }
      }).$promise.catch(angular.noop);
    }
    return cancelPromise.finally(function () {
      finishWorldpayInvoiceSession();
    });
  }

  function buildWorldpayInvoiceApplyWrapper(paymentDetails, worldpayReturnParams) {
    var worldpayResults = buildWorldpayInvoiceResultsFromReturnParams(worldpayReturnParams);
    return {
      company: paymentDetails.parameters.company,
      division: paymentDetails.parameters.division,
      location: paymentDetails.parameters.location,
      customerNumber: paymentDetails.parameters.customerNumber,
      preGeneratedInvoiceNumber: worldpayReturnParams.SalesOrderNumber || paymentDetails.parameters.preGeneratedInvoiceNumber,
      worldpayResults: worldpayResults
    };
  }

  function processWorldpayInvoiceReturn() {
    var worldpayReturnParams = getWorldpayReturnParams();
    var paymentDetails = parseStoredInvoicePaymentDetails();
    pendingWorldpayInvoiceReturnState = (paymentDetails && paymentDetails.returnState) || null;

    if (isWorldpayInvoiceReturn(worldpayReturnParams)) {
      clearWorldpayReturnUrl();
      if (!isWorldpayInvoicePaymentApproved(worldpayReturnParams)) {
        cancelPendingWorldpayInvoicePayment(paymentDetails, worldpayReturnParams);
        return;
      }
      if (paymentDetails && paymentDetails.selectedInvoices) {
        submitWorldpayInvoiceApply(buildWorldpayInvoiceApplyWrapper(paymentDetails, worldpayReturnParams));
        return;
      }
      globalAlertService.addError('mydealer.ui.invoices.ach_payment_auth_fail');
      finishWorldpayInvoiceSession();
      return;
    }

    if (!isBrowserPageReload() || !worldpayUrlService.hasPendingInvoicePayment()) {
      return;
    }
    var recoveredWrapper = worldpayUrlService.getStoredInvoicePaymentApplyWrapper();
    if (recoveredWrapper) {
      submitWorldpayInvoiceApply(recoveredWrapper);
    } else {
      finishWorldpayInvoiceSession();
    }
  }

  processWorldpayInvoiceReturn();

  $scope.invoices.content.forEach(invoice => {
    if (sessionStorage.getItem(invoice.transactionIdString + 'amt')) {
      invoice.appliedAmountSelected = sessionStorage.getItem(invoice.transactionIdString + 'amt');
    }
    if (sessionStorage.getItem("selectAllToggle") === "true" && !sessionStorage.getItem(invoice.transactionIdString + 'unchk') && invoice.invoiceType.symbol != 'X')
      invoice.selected = true;
    else if ((sessionStorage.getItem(invoice.transactionIdString + 'chk') ||
      sessionStorage.getItem(invoice.transactionIdString + 'amt')) && invoice.invoiceType.symbol != 'X')
      invoice.selected = true;
  });
  $scope.calculateTotalAppliedAmount();
  $scope.isSelectedCheckbox = function (event, invoice) {
    if (invoice.selected) {
      sessionStorage.removeItem(invoice.transactionIdString + 'chk');
      sessionStorage.setItem(invoice.transactionIdString + 'unchk', 'true');
    } else {
      sessionStorage.setItem(invoice.transactionIdString + 'chk', 'true');
      sessionStorage.removeItem(invoice.transactionIdString + 'unchk');
    }
  }

  function getSortParams(sortParams) {
    if (sortParams) {
      if (sortParams.sort === 'location' || sortParams.sort === 'billingHistoryCashReceiptId.location') {
        sortParams.sort = $scope.filters.status === 'O' && userConfiguration.usesInHouseAR ? 'billingHistoryCashReceiptId.location' : 'location';
      } else if (sortParams.sort === 'invoiceTotal' || sortParams.sort === 'outstandingAmount') {
        sortParams.sort = $scope.filters.status === 'O' && userConfiguration.usesInHouseAR ? sortParams.sort : 'location';
      }
    }
    return sortParams;
  }

  $scope.search = function (event, property, direction) {
    if (event) {
      event.preventDefault(); // prevent default form submit (IE10)
    }
    if ($scope.filtersform.$valid) {
      var params = {};
      var sortParams = angular.fromJson($stateParams.invoicesPagination);
      if (property && direction) {
        sortParams.sort = property;
        sortParams.direction = direction;
      }
      sortParams.page = 0;
      params.forceRefresh = Math.random();
      params.invoicesPagination = angular.toJson(getSortParams(sortParams));

      //add filters
      params.invoicesFilters = angular.toJson($scope.filters);

      //add keywords
      params.search = $scope.terms.keywords;
      $state.go('.', params);
      return true;
    }
    return false;
  };

  $scope.toggleFilters = function () {
    $scope.showFilters = !$scope.showFilters;
  };

  $scope.getPDFUrl = function (transactionIdString) {
    return (appConfigurationService.basePath + '/rest/invoicehistory/invoiceAsPdf?transactionId=' + transactionIdString);
  };

  $scope.showEmailForm = function () {
    $scope.emailForm.toggle = true;
  };

  $scope.downloadSelected = function () {
    var param = {searchedStatus: $scope.searchedStatus};
    invoiceHistoryResource.invoices(param, invoicesFilters).get(
      null,
      function () {
      },
      globalAlertService.handleErrorResponse
    ).$promise.then(function (response) {
      let data = JSON.stringify(response);
      let allInvoices = JSON.parse(data);

      let processedInvoices = [];
      JSON.parse(allInvoices).forEach(invoice => {
        if (sessionStorage.getItem("selectAllToggle") === "true" && !sessionStorage.getItem(invoice.transactionIdString + 'unchk') && invoice.invoiceType.symbol != 'X') {
          invoice = angular.copy(invoice);
          invoice.selected = true;
        } else if (sessionStorage.getItem(invoice.transactionIdString + 'chk') && invoice.invoiceType.symbol != 'X') {
          invoice = angular.copy(invoice);
          invoice.selected = true;
        }
        processedInvoices.push(invoice);
      });

      var selectedInvoices = [];
      processedInvoices.forEach(function (current) {
        if (current.selected) {
          selectedInvoices.push(current.transactionIdString);
        }
      });

      if (selectedInvoices.length == 0) {
        $scope.invoices.content.forEach(invoice => {
          if (invoice.selected)
            selectedInvoices.push(invoice.transactionIdString);
        })
      }

      if (selectedInvoices.length > 0) {
        invoiceHistoryResource.invoiceListAsZip.get(
          {
            'invoiceTransactionIdList': selectedInvoices
          },
          function () {
            selectedInvoices.forEach(invoice => {
              if (sessionStorage.getItem(invoice + 'chk')) {
                sessionStorage.removeItem(invoice + 'chk');
              }
            });
            sessionStorage.clear();
            $scope.search();
          },
          globalAlertService.handleErrorResponse
        );
      }

    });


  };

  function openTwoCPPortal(clientId, portalId) {
    var w = 820;
    var h = 500;
    var y = $window.top.outerHeight / 2 + $window.top.screenY - (h / 2);
    var x = $window.top.outerWidth / 2 + $window.top.screenX - (w / 2);
    return $window.open(appConfigurationService.getTwoCPPaymentPath(clientId, portalId), '_blank',
      'resizeable=true, scrollbars=yes, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);
  }

  function parsingAmount(amount) {
    return parseFloat(amount.replace(/,/g, '')).toFixed(2);
  }

  // Pay a specific invoice (used for mobile view)
  $scope.payInvoiceMobile = function () {
    var invoiceSelected;
    $scope.invoices.content.forEach(function (current) {
      if (current.selected) {
        invoiceSelected = current;
      }
    });
    $uibModal.open({
      templateUrl: 'app/scripts/modules/my-account/views/templates/generic-payment.html',
      controller: 'genericPaymentController',
      size: 'sm',
      animation: true,
      windowClass: 'center-modal',
      keyboard: false,
      backdrop: 'static',
      resolve: {
        properties: function () {
          return {
            title: 'mydealer.ui.global.pay',
            invoice: invoiceSelected,
            updatedSelected: function (lumpSumAmount) {
              invoiceSelected.appliedAmountSelected = lumpSumAmount;
              $scope.updateSelected(invoiceSelected)
            },
            callback: function (lumpSumAmount) {
              invoiceSelected.appliedAmountSelected = lumpSumAmount;
              $scope.paySelected();
            }
          };
        }
      }
    });
  };

  // Pay a specific lump sum (equates to adjustment line in cash receipts)
  $scope.payLump = function () {
    $uibModal.open({
      templateUrl: 'app/scripts/modules/my-account/views/templates/generic-lump-payment.html',
      controller: 'genericLumpPaymentController',
      size: 'md',
      animation: true,
      windowClass: 'center-modal',
      keyboard: false,
      backdrop: 'static',
      resolve: {
        properties: function () {
          return {
            title: 'mydealer.ui.invoices.submit.lump_payment',
            callback: function (lumpSumAmount) {
              var selectedInvoices = [];
              selectedInvoices.push({
                appliedAmount: parsingAmount(lumpSumAmount),
                location: userConfiguration.businessLocation,
                adjustment: true
              });
              if (lumpSumAmount > accountSummary.totalOutstanding) {
                confirmLeavePaymentPortal(selectedInvoices);
              } else {
                $scope.processPayments(selectedInvoices);
              }
            }

          };
        }
      }
    });
  };

  function confirmLeavePaymentPortal(selectedInvoices) {
    $uibModal.open({
      templateUrl: 'app/scripts/modules/my-account/views/templates/confirmation-view.html',
      controller: 'confirmationController',
      size: "sm",
      animation: false,
      windowClass: 'center-modal',
      keyboard: false,
      backdrop: 'static',
      resolve: {
        properties: function () {
          return {
            labelText: `${'mydealer.ui.invoices.pay_selected.overpayment'}`,
            buttons: {
              yes: `${'mydealer.ui.global.yes'}`,
              no: `${'mydealer.ui.global.no'}`
            }
          };
        }
      }
    }).result.then(function (value) {
      if (value === "yes") {
        $scope.processPayments(selectedInvoices);
      }
    });
  }

  //Pay the selection invoices from selection
  $scope.paySelected = function () {

    var param = {searchedStatus: $scope.searchedStatus};
    invoiceHistoryResource.invoices(param, invoicesFilters).get(
      null,
      function () {
      },
      globalAlertService.handleErrorResponse
    ).$promise.then(function (response) {
      let data = JSON.stringify(response);
      let allInvoices = JSON.parse(data);

      let processedInvoices = [];
      JSON.parse(allInvoices).forEach(invoice => {
        if (sessionStorage.getItem(invoice.transactionIdString + 'amt')) {
          invoice = angular.copy(invoice)
          invoice.selected = true
          invoice.appliedAmountSelected = sessionStorage.getItem(invoice.transactionIdString + 'amt')
        }
        processedInvoices.push(invoice);
      });


      var isOverPayment = false;
      var selectedInvoices = [];
      var currency = null;
      var isCurrencyChanged = false;
      processedInvoices.forEach(function (current) {

        if (current.selected &&
          !$scope.hasAmount(current.appliedAmount) &&
          $scope.hasAmount(parseInt(current.appliedAmountSelected))) {
          selectedInvoices.push({
            transactionId: current.transactionIdString,
            currencyType: current.currency,
            appliedAmount: parsingAmount(current.appliedAmountSelected),
            location: current.billingHistoryCashReceiptId.location,
            company: current.billingHistoryCashReceiptId.company,
            division: current.billingHistoryCashReceiptId.division,
            customerNumber: current.customerNumber,
            customerName: current.customerName,
            invoiceDate: current.billingDate,
            invoiceNumber: current.billingHistoryCashReceiptId.salesOrderNumber,
            sequence: current.sequence
          });
          if (currency !== null && currency !== current.currency) {
            isCurrencyChanged = true;
          }
          currency = current.currency;
          if (current.appliedAmountSelected > current.outstandingAmount) {
            isOverPayment = true;
          }
        }
      });
      if (isCurrencyChanged) {
        globalAlertService.addError('mydealer.ui.invoices.invalid.currency_type');
        return;
      }
      if (isOverPayment == true) {
        confirmLeavePaymentPortal(selectedInvoices);
      } else {
        $scope.processPayments(selectedInvoices);
      }

    });


  };

  function validateResponse(response, selectedInvoices) {
    if (response.transaction && response.successful) {
      globalAlertService.addSuccess('mydealer.ui.invoices.ach_payment_auth_success');
    } else if (response.lastError.description !== undefined) {
      globalAlertService.addError(response.lastError.description);
    } else {
      globalAlertService.addError('mydealer.ui.invoices.ach_payment_auth_fail');
    }
    hidePaymentSubmitDialog();
    selectedInvoices.forEach(invoice => {
      if (sessionStorage.getItem(invoice.transactionId + 'amt')) {
        sessionStorage.removeItem(invoice.transactionId + 'amt');
        sessionStorage.removeItem(invoice.transactionId + 'chk');
      }
    });
    $scope.search();
  }

  const updateSelectedInvoiceList = (selectedInvoices) => {
    if (selectedInvoices && selectedInvoices.length) {
      selectedInvoiceList = selectedInvoices
        .map(invoice => invoice.invoiceNumber || 'Lump Payment')
        .join(', ');
    }
  };

  const setTimeOutFunction = () => {
    timeOutId = setTimeout(() => {
      isTimeout = true;
      hidePaymentSubmitDialog();
      const message = $filter('language')('mydealer.ui.invoices.ach_payment_timeout_message1') + ' ' + selectedInvoiceList + '.' + '<br>' + $filter('language')('mydealer.ui.invoices.ach_payment_timeout_message2') ;;
      globalAlertService.addError(message);
    }, 30000);
  };

  const readVersapayCreditCardPayment = (parameters, selectedInvoices) => {
    if(!isTimeout) {
      twocpResource.readCreditCardPayment(parameters).post(selectedInvoices).$promise.then(function (response) {
        clearTimeout(timeOutId);
        validateResponse(response, selectedInvoices);
      }).catch(() => {
        readVersapayCreditCardPayment(parameters, selectedInvoices);
      });
    }
  };

  function readVersapayAuthorizationResult(modalInstance, parameters, selectedInvoices) {
    angular.element($window).off('beforeunload', confirmLeavePaymentPortal);
    modalInstance.dismiss();
    showPaymentSubmitDialog();
    readVersapayCreditCardPayment(parameters, selectedInvoices);
  }

  $scope.submitBlockedPopupOrder = function () {
    $scope.blockedPopupDetails.parameters.requestId = '';
    $scope.blockedPopupDetails.parameters.preGeneratedInvoiceNumber = $scope.blockedPopupDetails.preGeneratedInvoiceNumber;
    if ($scope.blockedPopupDetails) {
      readVersapayAuthorizationResult($scope.blockedPopupDetails.modalInstance, $scope.blockedPopupDetails.parameters, $scope.blockedPopupDetails.selectedInvoices);
    }
  };

  function buildWorldpayInvoicePaymentRetryWrapper(paymentWrapper) {
    if (!paymentWrapper) {
      return null;
    }
    return {
      company: paymentWrapper.company,
      division: paymentWrapper.division,
      location: paymentWrapper.location,
      customerNumber: paymentWrapper.customerNumber,
      preGeneratedInvoiceNumber: paymentWrapper.preGeneratedInvoiceNumber
    };
  }

  function isWorldpayCashReceiptApplyFailure(response) {
    if (!response || !response.lastError) {
      return false;
    }
    var message = (response.lastError.description || response.lastError.error || '').toLowerCase();
    return message.indexOf('cash receipts failed') >= 0 || message.indexOf('applying cash receipts failed') >= 0;
  }

  function clearPendingWorldpayInvoiceRetry() {
    pendingWorldpayInvoicePaymentRetryWrapper = null;
    pendingWorldpayInvoicePaymentSelectedInvoices = null;
  }

  function abandonWorldpayInvoiceRetry() {
    clearPendingWorldpayInvoiceRetry();
    finishWorldpayInvoiceSession();
  }

  function retryWorldpayInvoicePaymentApply() {
    if (!pendingWorldpayInvoicePaymentRetryWrapper) {
      return;
    }
    // Cash-receipt retry has no surcharge prompt — validate response directly.
    showPaymentSubmitDialog();
    var wrapper = pendingWorldpayInvoicePaymentRetryWrapper;
    var selectedInvoices = pendingWorldpayInvoicePaymentSelectedInvoices || [];
    worldpayResource.readInvoicePayment.post(wrapper).$promise.then(function (data) {
      validateWorldpayInvoiceResponse(data, selectedInvoices, null, wrapper);
    }).catch(function (response) {
      handleReadInvoicePaymentApplyFailure(response, wrapper);
    });
  }

  function promptWorldpayInvoicePaymentRetry() {
    $uibModal.open({
      templateUrl: 'app/scripts/modules/my-account/views/templates/confirmation-view.html',
      controller: 'confirmationController',
      size: 'sm',
      animation: false,
      windowClass: 'center-modal',
      keyboard: false,
      backdrop: 'static',
      resolve: {
        properties: function () {
          return {
            headerText: 'mydealer.ui.invoices.process_payment',
            labelText: 'mydealer.ui.invoices.ach_payment_retry_prompt'
          };
        }
      }
    }).result.then(function (value) {
      if (value === 'yes') {
        retryWorldpayInvoicePaymentApply();
      } else {
        abandonWorldpayInvoiceRetry();
      }
    }, abandonWorldpayInvoiceRetry);
  }

  function validateWorldpayInvoiceResponse(response, selectedInvoices, worldpayResults, paymentWrapper) {
    if (response && response.successful) {
      clearPendingWorldpayInvoiceRetry();
      worldpayUrlService.clearInvoicePaymentSession();
      globalAlertService.addSuccess('mydealer.ui.invoices.ach_payment_auth_success');
      hidePaymentSubmitDialog();
      clearPaidInvoiceSelectionStorage(selectedInvoices);
      restoreInvoiceReturnState({ forceRefresh: true });
      return;
    }
    if (response && response.lastError && (response.lastError.description !== undefined || response.lastError.error)) {
      globalAlertService.addError(response.lastError.description || response.lastError.error);
      if (isWorldpayCashReceiptApplyFailure(response)) {
        pendingWorldpayInvoicePaymentRetryWrapper = buildWorldpayInvoicePaymentRetryWrapper(paymentWrapper);
        pendingWorldpayInvoicePaymentSelectedInvoices = selectedInvoices;
        promptWorldpayInvoicePaymentRetry();
        hidePaymentSubmitDialog();
        return;
      }
    } else if (worldpayResults) {
      var comment = $filter('language')('mydealer.ui.invoices.ach_payment_auth_fail');
      globalAlertService.addError(comment + ' (' + worldpayResults.expressResponseCode + ' - ' + worldpayResults.expressResponseMessage + ')');
    } else {
      globalAlertService.addError('mydealer.ui.invoices.ach_payment_auth_fail');
    }
    hidePaymentSubmitDialog();
    finishWorldpayInvoiceSession();
  }

  function promptWorldpayInvoiceSurchargeAcceptance(worldpayResponse, wrapper) {
    hidePaymentSubmitDialog();
    $uibModal.open({
      templateUrl: 'app/scripts/modules/my-account/views/templates/confirmation-view.html',
      controller: 'confirmationController',
      size: 'sm',
      animation: false,
      windowClass: 'center-modal',
      keyboard: false,
      backdrop: 'static',
      resolve: {
        properties: function () {
          return {
            headerText: 'mydealer.ui.checkout.surcharge_prompt_header',
            labelText: $filter('language')('mydealer.ui.checkout.surcharge_prompt_body', $filter('currency')(worldpayResponse.expressResponse.transaction.surchargeAmount))
          };
        }
      }
    }).result.then(function (value) {
      if (value === 'yes') {
        showPaymentSubmitDialog();
        var surchargeParams = {
          authorizationAmount: worldpayResponse.expressResponse.transaction.transactionAmount,
          surchargeAmount: worldpayResponse.expressResponse.transaction.surchargeAmount,
          useToken: worldpayResponse.expressResponse.paymentAccount.paymentAccountID,
          tokenHash: worldpayResponse.expressResponse.card.cardNumber
        };
        worldpayResource.acceptInvoiceSurcharge(surchargeParams).post(wrapper).$promise.then(function (data) {
          validateWorldpayInvoiceResponse(data, wrapper.customerPayInvoiceDTOList, null, wrapper);
        }).catch(function (response) {
          globalAlertService.handleErrorResponse(response);
          hidePaymentSubmitDialog();
          finishWorldpayInvoiceSession();
        });
      } else {
        globalAlertService.addError('mydealer.ui.checkout.surcharge_declined');
        finishWorldpayInvoiceSession();
      }
    });
  }

  function processWorldpayPayment(selectedInvoices, parameters, isAch) {
    parameters.location = parameters.location || $scope.getLocation();
    parameters.siteLocation = $window.location.origin;
    parameters.isAch = isAch;
    worldpayResource.authorizeInvoicePayment(parameters).post(selectedInvoices).$promise.then(function (results) {
      if (results.worldpayPortalAvailable && results.worldPayUrl) {
        worldpayUrlService.persistInvoicePaymentSession({
          selectedInvoices: selectedInvoices,
          parameters: {
            company: parameters.company,
            division: parameters.division,
            location: parameters.location,
            customerNumber: parameters.customerNumber,
            preGeneratedInvoiceNumber: results.preGeneratedSalesOrderNumber
          },
          returnState: buildInvoiceReturnState()
        });
        $window.open(results.worldPayUrl, '_self');
      } else {
        worldpayUrlService.clearInvoicePaymentSession();
        globalAlertService.addError('mydealer.ui.checkout.worldpay_error');
      }
    }).catch(function (response) {
      worldpayUrlService.clearInvoicePaymentSession();
      globalAlertService.handleErrorResponse(response);
    });
  }

  function processVersaPayCreditCardPayment(selectedInvoices, parameters) {
    if ($scope.payByCreditCard) {
      $uibModal.open({
        templateUrl: 'app/scripts/modules/shopping-cart/views/credit-card-processing-prompt.html',
        scope: $scope,
        controller: function ($uibModalInstance) {
          parameters.location = userConfiguration.businessLocation;
          twocpResource.authorizeCreditCardPayment(parameters).post(selectedInvoices).$promise.then(function (data) {
            if (!data.twoCPPortalAvailable) {
              $uibModalInstance.dismiss();
              globalAlertService.addError('mydealer.ui.checkout.credit_card_portal_fail');
            } else {
              angular.element($window).on('beforeunload', confirmLeavePaymentPortal);
              var twoCPWindow = openTwoCPPortal($scope.paymentAgencies.clientId, data.portalId);
              if (!twoCPWindow || twoCPWindow.closed || typeof twoCPWindow.closed === 'undefined') {
                $scope.blockedPopupDetails = {
                  modalInstance: $uibModalInstance,
                  parameters: parameters,
                  selectedInvoices: selectedInvoices,
                  preGeneratedInvoiceNumber: data.preGeneratedSalesOrderNumber
                };
              } else {
                isTimeout = false;
                var timer = setInterval(function () {
                  if (twoCPWindow.closed) {
                    setTimeOutFunction();
                    $uibModalInstance.dismiss();
                    clearInterval(timer);
                    parameters.requestId = data.portalId;
                    parameters.preGeneratedInvoiceNumber = data.preGeneratedSalesOrderNumber;
                    updateSelectedInvoiceList(selectedInvoices);
                    readVersapayAuthorizationResult($uibModalInstance, parameters, selectedInvoices);
                  }
                }, 1000);
              }
            }
          }).catch(function () {
            $uibModalInstance.dismiss();
            globalAlertService.addError('mydealer.ui.checkout.credit_card_auth_fail');
          });
        },
        size: 'md',
        animation: true,
        windowClass: 'center-modal',
        keyboard: false,
        backdrop: 'static'
      });
    }
  }

  function readVersapayACHWeb(parameters, selectedInvoices) {
    if (!isTimeout) {
      twocpResource.readACHWeb(parameters).post(selectedInvoices).$promise.then(function (response) {
        clearTimeout(timeOutId);
        validateResponse(response, selectedInvoices);
      }).catch(() => {
        readVersapayACHWeb(parameters, selectedInvoices);
      });
    }
  }

  function processVersapayACHPayment(selectedInvoices, parameters) {

    $uibModal.open({
      templateUrl: 'app/scripts/modules/my-account/views/templates/process-bank-payment.html',
      controller: function ($uibModalInstance) {
        parameters.location = $scope.getLocation();
        twocpResource.authorizeACHWeb(parameters).post(selectedInvoices).$promise.then(function (data) {
          if (!data.portal.id) {
            $uibModalInstance.dismiss();
            globalAlertService.addError('mydealer.ui.invoices.ach_payment_portal_fail');
          } else {
            var twoCPWindow = $scope.openTwoCPPortal($scope.achPaymentAgencies.clientId, data.portal.id);
            if (!twoCPWindow || twoCPWindow.closed || typeof twoCPWindow.closed === 'undefined') {
              globalAlertService.addError('mydealer.ui.checkout.fail');
            } else {
              isTimeout = false;
              var timer = setInterval(function () {
                if (twoCPWindow.closed) {
                  setTimeOutFunction();
                  clearInterval(timer);
                  $uibModalInstance.dismiss();
                  showPaymentSubmitDialog();
                  parameters.requestId = data.portal.id;
                  parameters.preGeneratedInvoiceNumber = data.preGeneratedInvoiceNumber;
                  updateSelectedInvoiceList(selectedInvoices);
                  readVersapayACHWeb(parameters, selectedInvoices);
                }
              }, 1000);
            }
          }
        }).catch(function () {
          hidePaymentSubmitDialog();
          globalAlertService.addError('mydealer.ui.invoices.ach_payment_auth_fail');
        });
      },
      size: 'md',
      animation: true,
      windowClass: 'center-modal',
      keyboard: false,
      backdrop: 'static'
    });
  }


  function processAuthDotNetPayment(selectedInvoices, parameters, callback) {
    parameters.location = $scope.getLocation();
    parameters.iframeCommunicationURL = $location.absUrl().split('#')[0] + 'app/scripts/modules/my-account/views/iframeCommunicator.html';
    var compositeRequest = {
      authDotNetProperties: authDotNetProperties,
      customerPayInvoiceDTOList: selectedInvoices,
      contactDetailsDTO: $scope.myProfile
    };
    authorizeDotNetResource.authorizeDotNetPaymentPageResponse(parameters).post(compositeRequest).$promise.then(function (data) {
      if (data) {
        $uibModal.open({
          templateUrl: 'app/scripts/modules/my-account/views/templates/authorize-dot-net-payment.html',
          controller: 'authorizeDotNetController',
          resolve: {
            properties: function () {
              return {
                callback: callback,
                formToken: data.token,
                preGeneratedInvoiceNumber: data.preGeneratedInvoiceNumber,
                parameters: parameters,
                selectedInvoices: selectedInvoices,
                authDotNetHostedPaymentURL: data.authDotNetHostedPaymentURL
              };
            }

          },
          size: 'lg',
          animation: true,
          windowClass: 'center-modal-custom-width',
          keyboard: false,
          backdrop: 'static'
        });
      }
    }).catch(function (response) {
      globalAlertService.handleErrorResponse(response);
    });
  }


  function paymentSelectionModal(selectedInvoices, parameters) {
    $uibModal.open({
      templateUrl: 'app/scripts/modules/my-account/views/templates/payment-type-selection-modal.html',
      controller: 'paymentTypeSelectionController',
      size: 'md',
      animation: true,
      windowClass: 'center-modal',
      keyboard: false,
      backdrop: 'static',
      resolve: {
        properties: function () {
          return {
            callback: function (selectedType) {
              if (selectedType === 'ACH' && $scope.payByAuthDotNet) {
                processAuthDotNetPayment(selectedInvoices, parameters, $scope.search);
              } else if (selectedType === 'ACH' && $scope.achPaymentAgencies.twoCPACHEnabled) {
                processVersapayACHPayment(selectedInvoices, parameters);
              } else if (selectedType === 'ACH' && $scope.achPaymentAgencies.worldpayACHEnabled) {
                processWorldpayPayment(selectedInvoices, parameters, true);
              } else if ($scope.payByCreditCard) {
                processVersaPayCreditCardPayment(selectedInvoices, parameters);
              } else if ($scope.payByWorldPay) {
                processWorldpayPayment(selectedInvoices, parameters);
              }
            }
          };
        }
      }
    });
  }

  $scope.processPayments = function (selectedInvoices) {
    globalAlertService.clearErrors();
    var parameters = {
      company: userConfiguration.contactId.company,
      division: userConfiguration.contactId.division,
      customerNumber: userConfiguration.contactId.customerNumber
    };
    var invalidAmount = null;
    selectedInvoices.forEach(function (invoice) {
      if (isNaN(invoice.appliedAmount) || Math.abs(invoice.appliedAmount) > 999999999.99 || (invoice.appliedAmount) <= 0) {
        invalidAmount = invoice.appliedAmount;
      }
    });

    if (invalidAmount || selectedInvoices.length <= 0) {
      globalAlertService.addError('mydealer.ui.invoices.invalid_payment_amount');
      return;
    }

    var worldpayBoth = ($scope.payByWorldPay || $scope.achPaymentAgencies.worldpayACHEnabled) &&
      $scope.allowPaymentsOnAccount === 'BOTH_PAYMENT_TYPES' &&
      ($scope.payByWorldPay && $scope.achPaymentAgencies.worldpayACHEnabled);
    var versaPayOrAuthBoth = ($scope.payByAuthDotNet || $scope.achPaymentAgencies.twoCPACHEnabled) &&
      !$scope.paymentAgencies.disableTwoCP &&
      $scope.allowPaymentsOnAccount === 'BOTH_PAYMENT_TYPES';

    if (worldpayBoth || versaPayOrAuthBoth) {
      paymentSelectionModal(selectedInvoices, parameters);
    } else if ($scope.payByAuthDotNet && ($scope.allowPaymentsOnAccount === 'ACH_PAYMENT' || $scope.allowPaymentsOnAccount === 'BOTH_PAYMENT_TYPES')) {
      processAuthDotNetPayment(selectedInvoices, parameters, $scope.search);
    } else if ($scope.achPaymentAgencies.twoCPACHEnabled && ($scope.allowPaymentsOnAccount === 'ACH_PAYMENT' || $scope.allowPaymentsOnAccount === 'BOTH_PAYMENT_TYPES')) {
      processVersapayACHPayment(selectedInvoices, parameters);
    } else if ($scope.achPaymentAgencies.worldpayACHEnabled && ($scope.allowPaymentsOnAccount === 'ACH_PAYMENT' || $scope.allowPaymentsOnAccount === 'BOTH_PAYMENT_TYPES')) {
      processWorldpayPayment(selectedInvoices, parameters, true);
    } else if ($scope.payByCreditCard && ($scope.allowPaymentsOnAccount === 'CREDIT_CARD_PAYMENT' || $scope.allowPaymentsOnAccount === 'BOTH_PAYMENT_TYPES')) {
      processVersaPayCreditCardPayment(selectedInvoices, parameters);
    } else if ($scope.payByWorldPay && ($scope.allowPaymentsOnAccount === 'CREDIT_CARD_PAYMENT' || $scope.allowPaymentsOnAccount === 'BOTH_PAYMENT_TYPES')) {
      processWorldpayPayment(selectedInvoices, parameters);
    }
  };

  $scope.getInvoiceTotal = function (selectedInvoices) {
    var invoiceTotal = 0;
    selectedInvoices.forEach(function (invoice) {
      invoiceTotal = +Math.abs(invoice.appliedAmount) + invoiceTotal;
    });
    return invoiceTotal;
  }

  $scope.openTwoCPPortal = function (clientId, portalId) {
    var w = 820;
    var h = 500;
    var y = $window.top.outerHeight / 2 + $window.top.screenY - (h / 2);
    var x = $window.top.outerWidth / 2 + $window.top.screenX - (w / 2);
    return $window.open(appConfigurationService.getTwoCPPaymentPath(clientId, portalId), '_blank',
      'resizeable=true, scrollbars=yes, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);
  };

  $scope.emailSelected = function () {

    var param = {searchedStatus: $scope.searchedStatus};
    invoiceHistoryResource.invoices(param, invoicesFilters).get(
      null,
      function () {
      },
      globalAlertService.handleErrorResponse
    ).$promise.then(function (response) {
      let data = JSON.stringify(response);
      let allInvoices = JSON.parse(data);
      let processedInvoices = [];
      JSON.parse(allInvoices).forEach(invoice => {
        if (sessionStorage.getItem("selectAllToggle") === "true" && !sessionStorage.getItem(invoice.transactionIdString + 'unchk') && invoice.invoiceType.symbol != 'X') {
          invoice = angular.copy(invoice);
          invoice.selected = true;
        } else if (sessionStorage.getItem(invoice.transactionIdString + 'chk') && invoice.invoiceType.symbol != 'X') {
          invoice = angular.copy(invoice);
          invoice.selected = true;
        }
        processedInvoices.push(invoice);
      });

      var selectedInvoices = [];
      processedInvoices.forEach(function (current) {
        if (current.selected) {
          selectedInvoices.push(current.transactionIdString);
        }
      });

      if (selectedInvoices.length == 0) {
        $scope.invoices.content.forEach(invoice => {
          if (invoice.selected)
            selectedInvoices.push(invoice.transactionIdString);
        })
      }
      if (selectedInvoices.length > 0) {
        invoiceHistoryResource.myDealerInvoiceEmail.save(
          {
            'toEmailAddress': $scope.email.address,
            'invoiceTransactionIdList': selectedInvoices
          },
          function () {
            sessionStorage.clear();
            $scope.search();
            $scope.emailForm.toggle = false;
            globalAlertService.addSuccess('mydealer.ui.global.email_sent');
          },
          globalAlertService.handleErrorResponse
        );
      }

    });


  };

  $scope.showTaxSummary = function () {
    if ($scope.taxSummary.toggle === true) {
      $location.hash('tax-summary');
      $anchorScroll();
      return;
    }

    var parameters = {
      keywords: (search ? search : '')
    };

    if (invoicesFilters) {
      parameters.statusType = invoicesFilters.status;
      if (invoicesFilters.type) {
        parameters.invoiceType = invoicesFilters.type.symbol;
      }
      if (invoicesFilters.location) {
        parameters.location = invoicesFilters.location.location;
      }
      parameters.startDate = invoicesFilters.minDate ? new Date(invoicesFilters.minDate).getTime() : null;
      parameters.endDate = invoicesFilters.maxDate ? new Date(invoicesFilters.maxDate).getTime() : null;
    }

    invoiceHistoryResource.assignedInvoiceHistoryTaxSummary.query(
      parameters,
      function (value) {
        $scope.taxSummary.results = value;
        $scope.taxSummary.toggle = true;
        $location.hash('tax-summary');
        $anchorScroll();
      },
      globalAlertService.handleErrorResponse
    );
  };

  $scope.hideTaxSummary = function () {
    $scope.taxSummary.toggle = false;
    $location.hash('');
    $anchorScroll();
  };

  $scope.toggleCardMenu = function (event, invoice) {
    event.stopPropagation();
    invoice.isMenuOpen = !invoice.isMenuOpen;
  };

  $scope.selectCard = function (invoice) {
    $scope.emailForm.toggle = false;
    $scope.invoices.content.forEach(function (current) {
      current.selected = (current === invoice ? true : false);
    });
  };

  $scope.getPDF = function (transactionIdString, invoiceNumber) {

    var parameters = {
      transactionId: transactionIdString
    };
    var isUndefined = $scope.irInvoiceUndefined(invoiceNumber);
    if (isUndefined) {
      invoiceHistoryResource.pdf(parameters).get(
        null,
        function () {
        },
        function (response) {
          globalAlertService.addError('mydealer.ui.invoices.pdf_notGenerated');
        }
      );
    } else {
      invoiceHistoryResource.pdfIR(parameters).get(
        null,
        function () {
        },
        function (response) {
          globalAlertService.addError('mydealer.ui.invoices.pdf_notGenerated');
        }
      );
    }
  };

  $scope.getCsv = function () {
    var parameters = {searchedStatus: $scope.searchedStatus, keywords: search ? search : ''}
    parameters.startDate = invoicesFilters.minDate ? new Date(invoicesFilters.minDate).getTime() : null;
    parameters.endDate = invoicesFilters.maxDate ? new Date(invoicesFilters.maxDate).getTime() : null;
    parameters.location = invoicesFilters.location ? invoicesFilters.location.location : '';
    if (invoicesFilters.type) {
      parameters.invoiceType = invoicesFilters.type.symbol;
    }
    invoiceHistoryResource.csv(parameters).get(
      null,
      function () {
      },
      function (response) {
        globalAlertService.addError('mydealer.ui.invoices.csv_notGenerated');
      }
    );
  };
});
